// extracted by mini-css-extract-plugin
export default {"main__content":"Main_main__content__ldiAP","main__title":"Main_main__title__fqveq","main":"Main_main__F2ek1"};